import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <Link
          to="/"
          className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-6"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Retour au simulateur
        </Link>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">À propos</h1>
          
          <div className="prose max-w-none text-gray-600 space-y-6">
            <p className="text-lg">
              Ce simulateur vous aide à choisir le statut juridique le plus adapté à votre activité professionnelle en comparant les différentes options : Auto-entrepreneur, SARL, et SASU.
            </p>

            <div className="bg-blue-50 p-6 rounded-lg">
              <h2 className="text-xl font-semibold text-blue-900 mb-4">Fonctionnalités principales</h2>
              <ul className="list-disc list-inside space-y-3 text-blue-800">
                <li>Calcul automatique des charges sociales selon votre statut</li>
                <li>Estimation de l'impôt sur le revenu et l'impôt sur les sociétés</li>
                <li>Prise en compte du versement libératoire pour les auto-entrepreneurs</li>
                <li>Comparaison détaillée des coûts entre les différents statuts</li>
                <li>Recommandation du statut le plus avantageux financièrement</li>
              </ul>
            </div>

            <h2 className="text-xl font-semibold text-gray-900">Comment utiliser le simulateur</h2>
            <p>
              Pour obtenir une simulation précise, remplissez simplement les champs avec vos informations :
            </p>
            <ul className="list-disc list-inside space-y-2">
              <li>Type d'activité (vente de marchandises ou prestation de services)</li>
              <li>Chiffre d'affaires prévu</li>
              <li>Dépenses estimées</li>
              <li>Rémunération souhaitée</li>
              <li>Situation personnelle (âge, parts fiscales)</li>
            </ul>

            <p>
              Le simulateur calculera automatiquement les différentes charges et impôts pour chaque statut juridique, vous permettant de faire un choix éclairé pour votre activité.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;